import React, { FunctionComponent } from 'react';
import { ICON_CAMERA, Symbol } from '@doveit/lego';

import * as styles from './ImageCount.style';

export interface ImageCountProps {
  current?: number,
  total: number,
}

const ImageCount: FunctionComponent<ImageCountProps> = ({
  current,
  total,
}) => (
  <div css={styles.base}>
    <span
      css={styles.wrapper}
      data-ref="image-count"
    >
      <Symbol size={15} path={ICON_CAMERA} />

      <span css={styles.count}>
        {current && (
          <span>
            {current}/
          </span>
        )}

        <span>
          {total}
        </span>
      </span>
    </span>
  </div>
);

export default ImageCount;
